import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchTemplates, fetchGroups, newBroadcast } from '../../store/actions/broadcastAction';
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import InputBase from '@material-ui/core/InputBase';
import { Button, Typography, Grid, TextField, Select, MenuItem } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Swal from 'sweetalert2'

const useStyles = makeStyles((theme) => ({
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "5%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    bgContainer: {
      background: 'rgb(255,255,255)',
      background: 'linear-gradien180deg, rgba(255,255,255,1) 30%, rgba(240,240,240,1) 100%)',
      [theme.breakpoints.down("sm")]: {
        background: 'white',
        padding: '0 30px',
        marginTop: '-3rem'
      },
    },
    containerFormContact: {
      border: '2px solid #878787',
      borderRadius: '10px',
      paddingLeft: '20px',
      [theme.breakpoints.down("sm")]: {
        paddingLeft: '0'
      },
    },
    placeholderSelect: {
      fontSize: '14px',
      fontStyle: 'unset', 
      color: '#9f9f9f'
    }
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'transparent',
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);


const NewBroadcast = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [broadcastName, setBroadcastName] = useState('')
    const [templateId, setTemplateId] = useState('')
    const [contactGroupId, setContactGroupId] = useState('')
    const [preview, setPreview] = useState({
      text: '',
      fileUrl: ''
    })

    useEffect(() => {
      dispatch(fetchTemplates())
      dispatch(fetchGroups())
    }, [dispatch])

    const groups = useSelector(state => state.broadcastReducer.groups)
    const templates = useSelector(state => state.broadcastReducer.templates)
    const loading_BC = useSelector(state => state.broadcastReducer.loading_BC)
    const error_BC = useSelector(state => state.broadcastReducer.error_BC)

    useEffect(() => {
      if (loading_BC) {
          Swal.fire({
            title: 'Processing...',
            html: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
      }
      // if (error_BC) {
      //   Swal.close()        
      // }
      setTimeout(() => {
        Swal.close()
      }, 10000);
      // return () => {
      //   Swal.close()
      // }        
    }, [loading_BC])

    useEffect(() => {
      for (let i = 0; i < templates.length; i++) {
        if (templateId === templates[i]._id) {
          if (templates[i].type === 'text') {
            setPreview({...preview, text: templates[i].text})
          } else if (templates[i].type === 'image') {
            setPreview({
              ...preview,
              text: templates[i].caption,
              fileUrl: templates[i].imageUrl
            })            
          } else if (templates[i].type === 'pdf') {
            setPreview({
              ...preview,
              fileUrl: templates[i].pdfUrl
            })            
          }
        }        
      }
    }, [templateId])

    const handleNameChange = (event) => {
      setBroadcastName(event.target.value)
    }

    const handleChangeTemplateId = (event) => {
      setTemplateId(event.target.value);
    };

    const handleChangeContactGroupId = (event) => {
      setContactGroupId(event.target.value);
    };

    const handleHome = () => {
      history.push('/broadcast/template')
    };

    const handleNewBroadcast = (e) => {
      e.preventDefault()
      if (broadcastName && templateId && contactGroupId) {
        const payload = { broadcastName, templateId, contactGroupId }
        dispatch(newBroadcast(payload))
        history.push('/broadcast/report')
      } else {
        console.log('Data is incomplete');
      }
    };


    return (
        <React.Fragment>
        <Header page='CreateApp'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
          <Typography align="center" color="textPrimary" spacing={4} gutterBottom className="mt-30 reguler font-size-28">
            Buat Broadcast Baru
          </Typography>
          <main className={classes.layoutMainCreateApp}>
            <form>
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nama Broadcast</p>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    id="broadcastName"
                    name="broadcastName"
                    placeholder='Masukkan Nama Broadcast'
                    onChange={handleNameChange}
                    style={{marginBottom: "1.5rem"}}
                  />
                  <p className="font-size-16 reguler" style={{marginBottom: "-5px"}}>Pilih Grup Kontak</p>
                  <Select
                    fullWidth
                    displayEmpty
                    required
                    value={contactGroupId}
                    onChange={handleChangeContactGroupId}
                    input={<BootstrapInput />}
                    inputProps={{ 'aria-label': 'Without label' }}
                    style={{margin: '8px 0 4px 0', marginBottom: "1.5rem"}}
                  >
                    <MenuItem disabled value="">
                      <em className={classes.placeholderSelect}>{'Silahkan pilih grup kontak'}</em>
                    </MenuItem>
                      {
                        groups.map((group) => (
                          <MenuItem key={group._id} value={group._id} >
                            {group.groupName}
                          </MenuItem>
                      ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={6}> 
                  <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Pilih Template Message</p>
                  <Select
                    fullWidth
                    displayEmpty
                    required
                    value={templateId}
                    onChange={handleChangeTemplateId}
                    input={<BootstrapInput />}
                    inputProps={{ 'aria-label': 'Without label' }}
                    style={{margin: '8px 0 4px 0'}}
                  >
                    <MenuItem disabled value="">
                      <em className={classes.placeholderSelect}>{'Silahkan pilih nama template'}</em>
                    </MenuItem>
                      {
                        templates.map((template) => (
                          <MenuItem key={template._id} value={template._id}>
                            {template.name}
                          </MenuItem>
                      ))}
                  </Select>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12}>                          
                <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "5px"}}>Broadcast Preview</p>
                <TextField
                  id="message outlined-multiline-static"
                  variant="outlined"
                  margin="none"
                  size="small"
                  placeholder={preview.text}
                  defaultValue=""
                  required
                  fullWidth
                  multiline
                  rows={4}
                  name="message"
                  disabled
                  // value={message}
                />
              </Grid>
                          
              <div className="d-flex mt-15" style={{justifyContent: "flex-end"}}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="btn-white text-transform-unset"
                  style={{padding: "5px 40px", marginRight: "20px"}}
                  onClick={handleHome}
                >
                  Batal
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="btn-black text-transform-unset"
                  style={{padding: "5px 40px"}}
                  onClick={handleNewBroadcast}
                >
                  Buat Broadcast
                </Button>
              </div>
            </form>
          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default NewBroadcast